import React, { useState } from "react";
import "../styles/Formularios.css";
import InputGenerico from "./InputGenerico";
import Hardware from "./Hardware";
import { useApiFetch } from "../utils/apiFetch";
import { useGlobal } from "../context/ContenedorGlobal";
import InputBienesAutocomplete from "./InputBienesAutocomplete";

function ReactivarBienes() {

    const { logout } = useGlobal();
    const [serieBien, setSerieBien] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const [mostrarHardware, setMostrarHardware] = useState(false);
    const apiFetch = useApiFetch();

    // Función para activar los estados y validar el ingreso de uns serie
    const handleReactivar = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");
        setLoading(true);

        if (!serieBien.trim()) {
            setError("Debe ingresar la serie del bien.");
            setLoading(false);
            return;
        }

        try {

            const data = await apiFetch("reactivar_bienes.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ serie_bien: serieBien })
            }, logout);

            if (data.status === "ok") {
                setSuccess(data.message);
                setTimeout(() => setMostrarHardware(true), 3000);
            } else {
                setError(data.message || "Error al reactivar el bien.");
                setTimeout(() => setMostrarHardware(true), 3000);
            }
        } catch (err) {
            setError("Error de conexión con el servidor.");
        } finally {
            setLoading(false);
        }
    };

    // Render condicional
    if (mostrarHardware) {
        return <Hardware />;
    }

    return (
        <div className="sesion-form">

            {error && <div className="error">{error}</div>}
            {success && <div className="success">{success}</div>}

            <form onSubmit={handleReactivar}>

                <InputBienesAutocomplete
                    idSeleccionado={serieBien}
                    setIdSeleccionado={setSerieBien}
                    label="Ingrese la serie del bien a reactivar"
                    placeholder="MXL1234ABC"
                    title="Máximo 30 caracteres"
                    readOnly={false}
                    maxLength={30}
                />

                <div className="form-buttons">
                    <button type="submit" disabled={loading}>
                        {loading ? "Reactivando..." : "Reactivar bien"}
                    </button>
                </div>
            </form>
        </div>
    );
}

export default ReactivarBienes;